module.exports = __webpack_public_path__ + "assets/RetinaNarr-ExLight.818d4a05ac932f9410282c93ba2a0fab.woff2";